export const apiName: string = 'alarmes';
export const alarmeRoute: string = 'alarmes';
export const alarmestorage: string = 'alarmes';
export const alarmeModuleName: any = {plural: 'Alarmes', single: 'Alarme'};

export const apiBemAlarme: string = 'bens-alarmes';
export const apiCercaAlarme: string = 'cercas-alarmes';
export const apiEmailAlarme: string = 'emails-alarmes';
export const apiTemplateAlarme: string = 'templates';


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/alarmes/shared/data.service.ts
 **/